<template>
    <v-form @submit.prevent="validateForm" ref="form">
        <v-card dense class="rounded-4">
            <v-toolbar flat height="45px">
                <b>Add Linked Company Account</b>
                <v-spacer></v-spacer>
                <help-link appId="company" pageId="linked-account-create" color="black"></help-link> 
                <v-btn icon @click.native="closeDialog" :disabled="disabled">
                    X
                </v-btn>
            </v-toolbar>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline class="header-intro">
                {{ errorMessage }}
            </v-alert> 
            <v-alert :value="true" color="info" icon="info" outline class="header-intro">
                Create a linked company account to manage multiple SweldoNow accounts without logging out. Each account keeps its own payroll settings (calendar, cutoff, taxes, and workdays).
            </v-alert> 
            <v-card-text dense>
                <v-layout row wrap>
                    <v-flex xs12 sm12 :class="isMobile?'content-mobile':'content1'">
                        <v-text-field label="Company name"
                            prepend-inner-icon="store"
                            v-model="company"
                            :rules="[rules.required, rules.max_100]"
                            :disabled="disabled"
                            maxlength="100"
                            @keyup="error=false"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 :class="isMobile?'content-mobile':'content1'">
                        <v-select
                            prepend-inner-icon="factory"
                            label="Industry"
                            :items="industry_list"
                            :rules="[rules.required]" 
                            item-text="name"
                            item-value="name"
                            :disabled="disabled"
                            v-model="industry"
                        ></v-select>
                    </v-flex>
                </v-layout>
            </v-card-text>  
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1976D2" type="submit" :loading="loading" dark class="mr-20">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<script>

import registrationApi from '@/api/registration'

export default {
    data() {
        return {
            error: false,
            errorMessage: null,
            disabled: false,
            loading: false,
            rules: {
                required: value => !!value || 'Required.',
                max_100: value => value && value.length <= 100 || "Max 100 characters",
            },
            //fixed data
            industry_list: [
                { id: 1, name: 'Agriculture - Non-Plantation' },
                { id: 2, name: 'Agriculture - Plantation' },
                { id: 3, name: 'Construction' },
                { id: 4, name: 'Education' },
                { id: 5, name: 'E-Commerce' },
                { id: 6, name: 'Energy' },
                { id: 7, name: 'Healthcare' },
                { id: 8, name: 'Hospitality (Hotels and Restaurants)' },
                { id: 9, name: 'IT, BPO, and Business Services' },
                { id: 10, name: 'Manufacturing' },
                { id: 11, name: 'Real Estate' },
                { id: 12, name: 'Retail' },
                { id: 13, name: 'Tourism' },
                { id: 14, name: 'Other' }
            ],
            email: null,
            company: null,
            industry: null,
            firstName: null,
            lastName: null,
            position: null,
        }
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    methods: {
        validateForm() {
            if (this.$refs.form.validate()) {
                this.addLinkedAccount()
            }
        },
        async addLinkedAccount() {
            try {
                this.loading = true
                const data = {
                    company: this.company,
                    industry: this.industry,
                    firstName: this.$store.state.firstName,
                    lastName: this.$store.state.lastName,
                    position: 'SweldoNow Admin',
                    email: this.$store.state.email
                }
                const response = await registrationApi.addLinkedAccount(data)
                if (response && response.status==200) {
                    this.closeDialog()
                    this.$emit('send', response.data)
                }
                this.loading = false
                this.disabled = false
            }catch(error) {
                console.log(error)
                this.error = true
                this.errorMessage = error
            }
        },
        closeDialog() {
            this.$emit('update:dialogAddLinkAccount', false)
        }
    },
    computed: {
        isMobile() {
            return window.innerWidth < 600
        },
    },
    created() {}
}
</script>
<style scoped>
.content1 {
    padding: 0px 20px 0px 20px;
}
.content-mobile {
    padding: 0px 15px 0px 15px;
}
.header-intro {
    margin:15px 15px 0px 15px;
}
</style>